import { IFCMTokenBody } from 'src/types/FCMToken.type';
import http from 'src/utils/http';

export default class FCMTokenService {
  private url = '/fcm-token';

  public async register(body: IFCMTokenBody) {
    const { data } = await http.post<boolean>(`${this.url}`, body);
    return data;
  }
}
